module.exports = __webpack_public_path__ + "img/lespagina-small-wit.acaf17fe.png";